<template>
  <!--begin::Wrapper-->
  <div class="w-100">
    <!--begin::Input group-->
    <div class="fv-row">
      <div class="row">
        <!-- nombre Enfermedad -->
        <div class="col-md-12 mt-3">
          <label class="form-label">Nombre enfermedad:</label>
          <Field
            name="nombre_enfermedad"
            v-slot="{ field }"
            v-model="formData.nombre_enfermedad"
          >
            <input
              v-bind="field"
              type="text"
              class="form-control fuente"
              id="nombre_familiar"
              style="text-transform: uppercase"
              v-model="formData.nombre_enfermedad"
            />
          </Field>
          <ErrorMessage
            name="nombre_enfermedad"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- ¿Recibe medicación? -->
        <div class="col-md-12 mt-3">
          <label class="form-label">¿Recibe medicación?:</label>
          <Field
            name="toma_medicacion"
            v-slot="{ field }"
            v-model="formData.toma_medicacion"
          >
            <div class="form-check form-switch">
              <input
                v-bind="field"
                class="form-check-input"
                type="checkbox"
                id="flexSwitchCheckDefault"
                v-model="formData.toma_medicacion"
              />
            </div>
          </Field>
          <ErrorMessage
            name="medicarion"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- Medicación que recibe -->
        <div v-if="formData.toma_medicacion" class="col-md-12 mt-3">
          <label class="form-label">Medicación que recibe:</label>
          <Field
            name="medicacion"
            v-slot="{ field }"
            v-model="formData.medicacion"
          >
            <input
              v-bind="field"
              type="text"
              class="form-control fuente"
              id="nombre_familiar"
              style="text-transform: uppercase"
              v-model="formData.medicacion"
            />
          </Field>
          <ErrorMessage
            name="medicacion"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- observacion -->
        <div class="col-md-11 mt-3">
          <label class="form-label">Observación:</label>
          <Field
            name="observacionEnfermedad"
            v-slot="{ field }"
            v-model="formData.observacionEnfermedad"
          >
            <input
              v-bind="field"
              type="text"
              class="form-control fuente"
              id="nombre_familiar"
              style="text-transform: uppercase"
              v-model="formData.observacionEnfermedad"
            />
          </Field>
          <ErrorMessage
            name="observacionEnfermedad"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- boton de agregar -->
        <div class="col-md-1 mt-7">
          <button
            type="button"
            style="margin: 5px"
            class="btn btn-primary px-3"
            :disabled="!formData.nombre_enfermedad"
            @click="addDesease()"
          >
            Agregar
          </button>
        </div>
      </div>
      <!-- <span
        v-if="family.length === 0"
        class="fv-plugins-message-container invalid-feedback"
        >Debe registrar al menos un familiar.</span
      > -->
      <template>
        <Field name="desease" v-model="desease"> </Field>
        <ErrorMessage
          name="desease"
          class="fv-plugins-message-container invalid-feedback"
        ></ErrorMessage>
      </template>
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">N°</th>
          <th scope="col">Acciones</th>
          <th scope="col">Nombre enfermedad</th>
          <th scope="col">¿Recibe medicación?</th>
          <th scope="col">Medicación</th>
          <th scope="col">Observación</th>
        </tr>
      </thead>
      <tbody>
        <span v-if="desease.length === 0">
          No existen registros de enfermedades.
        </span>
        <tr v-else v-for="(value, index) in desease" :key="index">
          <th scope="row">{{ index + 1 }}</th>
          <td>
            <button
              type="button"
              class="btn px-3"
              v-if="!disabledEdit"
              @click="editRecord(value, index)"
            >
              <i
                title="Editar "
                style="font-size: 1.5em; color: Dodgerblue"
                class="fas fa-pencil"
              ></i>
            </button>
            <button type="button" class="btn px-3" @click="deleteRecord(index)">
              <i
                title="Eliminar"
                style="font-size: 1em; color: Mediumslateblue"
                class="fas fa-xmark fa-lg"
              ></i>
            </button>
          </td>
          <td>{{ value.nombre_enfermedad.toUpperCase() }}</td>
          <td>{{ booleanChange(value.toma_medicacion) }}</td>
          <td>{{ value.medicacion.toUpperCase() }}</td>
          <td>{{ value.observacionEnfermedad.toUpperCase() }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { defineComponent, ref, onMounted, reactive, computed } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { Field, ErrorMessage } from "vee-validate";
import filiation from "@/filiation/composables/useFiliation";
import { useRoute } from "vue-router";
export default defineComponent({
  name: "deseaseData",
  components: {
    Field,
    ErrorMessage,
  },
  setup() {
    const disabledEdit = ref(false);
    const route = useRoute();
    const { dataToEdit } = filiation();
    const formData = reactive({
      nombre_enfermedad: "",
      toma_medicacion: false,
      medicacion: "",
      observacionEnfermedad: "",
      id_enfermedadesppl: 0,
    });
    const desease = reactive([]);
    const addDesease = async () => {
      desease.push({ ...formData });
      resetFields();
    };
    const resetFields = () => {
      formData.nombre_enfermedad = "";
      formData.toma_medicacion = false;
      formData.medicacion = "";
      formData.observacionEnfermedad = "";
      formData.id_enfermedadesppl = 0;
    };
    const deleteRecord = (value) => {
      desease.splice(value, 1);
      //   for (let i = 0; i < family.value.length; i++) {
      //     if (family.value[i].invoice === invoice) {
      //       family.value.splice(i, 1);
      //     }
      //   }
    };
    const editRecord = (value, index) => {
      for (let i in desease) {
        if (i == index) {
          formData.nombre_enfermedad = desease[i].nombre_enfermedad;
          formData.toma_medicacion = desease[i].toma_medicacion;
          formData.medicacion = desease[i].medicacion;
          formData.observacionEnfermedad = desease[i].observacionEnfermedad;
          formData.id_enfermedadesppl = desease[i].id_enfermedadesppl;
          break;
        }
      }
      deleteRecord(index);
    };
    const booleanChange = (value) => {
      let bool = "";
      if (value == true) {
        bool = "SI";
      } else {
        bool = "NO";
      }
      return bool;
    };
    const dataEdit = computed(() => dataToEdit.value);
    const personDetails = computed(() => route.params.id_persona);
    const orderDetails = computed(() => route.params.id_orden_judicial);
    onMounted(() => {
      setCurrentPageBreadcrumbs("Datos de enfermedades", [
        "Registro privado de libertad",
      ]);
      if (personDetails.value !== "0" && orderDetails.value !== "0") {
        disabledEdit.value = true;
        const data = JSON.parse(localStorage.getItem("edit") || "{}");
        let i = data.enfermedades.length;
        while (i--) {
          desease[i] = data.enfermedades[i];
        }
      }
    });
    return {
      disabledEdit,
      formData,
      desease,
      dataEdit,
      addDesease,
      deleteRecord,
      editRecord,
      booleanChange,
    };
  },
});
</script>
<style>
.fuente {
  font-size: 0.97em;
  padding: 0.35em;
  font-weight: normal;
}
</style>
